(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3AdminClubPicker', {
            templateUrl: 'app/shared/admin-club-picker/admin-club-picker.component.html',
            controller: AdminClubPickerComponent
        });

    var noop = angular.noop,
        extend = angular.extend,
        data,
        initialized;

    AdminClubPickerComponent.$inject = ['$scope', '$transitions', '$q', '$state', 'user', 'Club', 'alert', 'defaultAdminClubSearchPageSize', 'adminClubPickerData', 'shared_resources'];
    function AdminClubPickerComponent($scope, $transitions, $q, $state, user, Club, alert, pageSize, adminClubPickerData, resources) {
        // Variables
        var ctrl = this,
            unhook;

        // Properties
        ctrl.searchValue = null;
        Object.defineProperty(ctrl, 'club', { get: getClub, set: setClub });
        Object.defineProperty(ctrl, 'isActive', { get: getIsActive });
        Object.defineProperty(ctrl, 'clubList', { get: getClubList });
        Object.defineProperty(ctrl, 'type', { get: getType });

        // Methods
        ctrl.$onInit = init;
        ctrl.search = search;

        /////////////////////////////////

        // API
        function init() {
            ctrl.searchValue = ctrl.club;
            $scope.$on('$destroy', $transitions.onBefore(true, hook));
            $scope.$on('$clubChanged', onClubChanged);
        }

        function search(text) {
            return ctrl.isActive ? adminClubPickerData.refresh(text).then(success, noop) : $q.reject();

            function success(response) {
                return response.data;
            }
        }

        // Property Accessors
        function getClub() {
            return $state.params.club;
        }
        function setClub(club) {
            if (ctrl.isActive && club)
                $state.go('.', { clubId: club.id, club: club });
        }
        function getIsActive() {
            var state = $state.current;
            return state.data && state.data.requireAdmin || false;
        }
        function getClubList() {
            return ctrl.isActive && adminClubPickerData.data || [];
        }
        function getType() {
            var total = adminClubPickerData.total,
                canShowAll = total <= pageSize;
            return !ctrl.isActive || !total ? 'none' : total === 1 ? 'text' : canShowAll ? 'dropdown' : 'typeahead';
        }

        // Watches
        function hook(transition) {
            transition.promise.finally(setSearchValue);
            
            function setSearchValue() {
                ctrl.searchValue = ctrl.club;
            }
        }

        function onClubChanged(e, newClub) {
            var club = ctrl.club,
                searchValue = ctrl.searchValue,
                clubList = ctrl.clubList,
                typeahead = ctrl.form.typeahead;

            // Text
            if (club && club.id === newClub.id)
                club.name = newClub.name;

            // Dropdown
            club = clubList && clubList.find(find);
            if (club != null) 
                club.name = newClub.name;

            // Typeahead
            club = searchValue;
            if (club && typeahead && club.id === newClub.id)
                typeahead.$$element.val(club.name);

            function find(club) {
                return club.id === newClub.id;
            }
        }
    }
})();
